export default "__VITE_ASSET__BhJVo9z0__"